import './Contact.css';
import { useState } from 'react';
import { FaGithub, FaLinkedin, FaEnvelope, FaFileDownload,FaPaperPlane } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLanguage } from '../LanguageContext';

function Contact() {
  const { t } = useLanguage();
  const [form, setForm] = useState({ name: '', email: '', message: '' });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      toast.error(t.contact.errorFields);
      return;
    }

    if (!validateEmail(form.email)) {
      toast.error(t.contact.errorEmail);
      return;
    }

    const templateParams = {
      ...form,
      reply_to: form.email,
    };

    emailjs.send('service_3j6q67f', 'template_ay9510a', templateParams, 'IKXBtF0qsH8PvGvT7')
      .then(() => {
        toast.success(t.contact.success);
        setForm({ name: '', email: '', message: '' });
      })
      .catch(() => {
        toast.error(t.contact.fail);
      });
  };

  return (
    <section className="contact-page">
      <h2>{t.contact.title}</h2>
      <p className="contact-subtext">
        {t.contact.subtitle}
      </p>

      <div className="contact-links">
        <a href="mailto:santhoshdayakar2002@gmail.com" title="Email" aria-label="Email">
          <FaEnvelope /> <span>Email</span>
        </a>
        <a href="https://linkedin.com/in/santhosh-dayakar" target="_blank" rel="noreferrer" title="LinkedIn" aria-label="LinkedIn">
          <FaLinkedin /> <span>LinkedIn</span>
        </a>
        <a href="https://github.com/S-15-77" target="_blank" rel="noreferrer" title="GitHub" aria-label="GitHub">
          <FaGithub /> <span>GitHub</span>
        </a>
        <a href="/Santhosh%20Dayakar%20Resume.pdf" download title="Download Resume" aria-label="Download Resume">
          <FaFileDownload /> <span>Resume</span>
        </a>
      </div>

      <form className="contact-form" onSubmit={handleSubmit} noValidate>
        <input
          type="text"
          name="name"
          placeholder={t.contact.namePlaceholder}
          required
          value={form.name}
          onChange={handleChange}
        />
        <input
          type="email"
          name="email"
          placeholder={t.contact.emailPlaceholder}
          required
          value={form.email}
          onChange={handleChange}
        />
        <textarea
          name="message"
          placeholder={t.contact.messagePlaceholder}
          rows="5"
          required
          value={form.message}
          onChange={handleChange}
        />
        <button type="submit">
          <FaPaperPlane style={{ marginRight: '8px' }}/>
          {t.contact.send}</button>
      </form>

      <ToastContainer position="top-center" autoClose={3000} />
    </section>
  );
}

export default Contact;
